import React from "react";
import { Col, Row } from "reactstrap";
import { H5, P } from "../../../AbstractElements";

export default function DropInputComponent({
  accept,
  onFiles,
  getFilesFromEvent,
}) {
  return (
    <div style={{ maxWidth: "100%", overflow: "hidden" }}>
      <Row className="justify-content-center align-items-center">
        <Col md="2" className="d-flex justify-content-center">
          <i className="icon-cloud-up" style={{ fontSize: "55px" }}></i>
        </Col>
        <Col md="6">
          <H5>Seleccione un archivo o arrastrelo y sueltelo aqui</H5>
          <P attrPara={{ style: { fontSize: "12px" } }}>
            JPG, PNG, DOC, DOCX o PDF, El tamaño del archivo no debe ser mayor a
            10 MB
          </P>
        </Col>
        <Col
          md="4"
          className="d-flex justify-content-center"
          style={{ marginTop: "1rem" }}
        >
          <label
            className="btn btn-outline-primary"
            style={{
              cursor: "pointer",
              padding: "0.6rem 1.75rem",
              borderRadius: "8px",
              fontWeight: 600,
              marginRight: "1rem",
              fontSize: "12px",
            }}
          >
            Seleccionar Archivo
            <input
              style={{ display: "none" }}
              type="file"
              accept={accept}
              multiple
              onChange={(e) => {
                getFilesFromEvent(e).then((chosenFiles) => {
                  onFiles(chosenFiles);
                  e.target.value = "";
                });
              }}
            />
          </label>
        </Col>
      </Row>
    </div>
  );
}
